export class Dictionary<T> {
  [K: string]: T;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/dictonary.model.ts